import { render } from "./parentContact.vue?vue&type=template&id=33c11f3a"
import script from "./parentContact.vue?vue&type=script&lang=js"
export * from "./parentContact.vue?vue&type=script&lang=js"

import "./parentContact.vue?vue&type=style&index=0&id=33c11f3a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__